import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import AcreditedInvestorProfilePageContainer from '@buyside/components/container/AccreditedInvestorProfilePage/accreditedInvestorProfilePageContainer';

const AccreditedInvestorProfilePageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the accredited investor page">
      <AcreditedInvestorProfilePageContainer />
    </ErrorBoundary>
  );
};

export default AccreditedInvestorProfilePageRoot;
